import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FeatureFlagModule } from '@directive/feature-flag/feature-flag.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputMaskModule } from 'primeng/inputmask';
import { PaginatorModule } from 'primeng/paginator';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { NavUsersComponent } from './nav-users.component';
import { TooltipModule } from 'primeng/tooltip';

const CommonModulesList: any[] = [
  NgSelectModule,
  ButtonModule,
  CheckboxModule,
  RadioButtonModule,
  InputMaskModule,
  TableModule,
  PaginatorModule,
  NgxPermissionsModule,
  FeatureFlagModule,
  TooltipModule,
];

@NgModule({
  declarations: [NavUsersComponent],
  imports: [...CommonModulesList, CommonModule, HttpClientModule, FormsModule, ReactiveFormsModule, RouterModule],
  exports: [...CommonModulesList, NavUsersComponent],
})
export class NavUserModule {}
